export class ResetPasswordModel {
    firstName: string;
    lastName: string;
    emailAddress: string;
    captchaId: string;
    captchaText: string;
}
